<template>
  <div class="flex-grid--full">
    <div
    v-for="(posts, i) in getPosts.stories"
    :key="i"   
    >
      <div
        v-if="posts.content.title === postTitle"
      >
        <Header
          :logo-white="false"
          :button="false"
          :background="true"
        />
        <BlogHeader
          :blogTitle= posts.content.title
          :blogSubTitle= posts.content.subtitle
          :callBack= posts.content.CallMe
          :AssetHeader= posts.content.image
          :height= posts.content.imgHeight
        />
        <div class="col-70 Content-Blok">
          <h1 class="onder">{{posts.content.title}}</h1>
          <h2>{{posts.content.title_alinea_1}}</h2>
          <p >{{posts.content.content_alinea_1}}</p>
          <h2>{{posts.content.title_alinea_2}}</h2>
          <p>{{posts.content.content_alinea_2}}</p>
          <h2>{{posts.content.title_alinea_3}}</h2>
          <p>{{posts.content.content_alinea_3}}</p>
        </div>
      </div>
    </div>

<!--
    <TrustCicles />
-->

    <div class="flex-column flex-grid--full align-center">
      <h2 class="content"> Wij zijn trots op onze TRUSTSCORE</h2>
      <div class="flex-grid col-70">
        <div class="col-2 onder"
            v-for="(ReviewItem, r) in getReview.stories"
            :key="r"      
        >
            <ReviewCard
              v-if="r < 2"
              :ReviewStars= ReviewItem.content.ReviewStars
              :ReviewDate= ReviewItem.content.ReviewDate
              :ReviewName= ReviewItem.content.ReviewName
              :ReviewHeader= ReviewItem.content.ReviewHeader
              :ReviewSubHeader= ReviewItem.content.ReviewSubHeader
              :ReviewDescription= ReviewItem.content.ReviewDescription
            />
        </div> 
      </div>       
    </div>

<!--
    <StickyLead
      buttonCTA = "Besparen ?"
    />
-->
    <Footer />
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import Header from "@/components/ComponentHeader";
import BlogHeader from "@/components/ComponentBlogHeader";
import ReviewCard from "@/components/ComponentReview";
import Footer from "@/components/ComponentFooter";
//import StickyLead from "@/components/ComponentStickyLead";
//import TrustCicles from "@/components/ComponentTrustCicles";

export default {
  name: 'BlogPagina',
  components: {
    Header,
    BlogHeader,
    ReviewCard,
    Footer
//    ,
//    StickyLead,
//    TrustCicles
  },
  props: {
    postTitle: {
      type: String,
      required: false,
      default: ""
    }
  }, 
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      story: {
        stories: {
          content: []
        }
      },
      data: "",
    }
  },
  computed: {
    ...mapGetters(["getPosts", "getReview"])
  }
}
</script>

<style scoped>

.Content-Blok {
  transform: translateY(-140px);
  background-color: #F2F2F2;
  padding: 40px;
  max-width: 760px;
  height: 100%;
}
.onder {
  margin-bottom: 64px;
}

@media (min-width: 600px) and (max-width: 1023px) {

}

@media (min-width: 240px) and (max-width: 720px) {

}

</style>
